import { PUBLIC_OFFER_COPY } from '../publicOffer';

export const AVANCE_LANDING_COPY = Object.freeze({
  eyebrow: 'Avance immédiate URSSAF',
  cinematic: ['Facturer 100 € pour un cours…', 'mais la famille ne paie que 50 € ?', 'Légalement !', 'Oui, c’est possible.'],
  explanation: 'Avec l’Avance immédiate, la famille ne règle que sa moitié : le crédit d’impôt de 50 % est déduit tout de suite, sous conditions. Toi, tu reçois la totalité.',
  professionalTitle: 'Enfin un outil d’avance immédiate spécialisé pour les cours particuliers !',
  professionalLead: 'De la demande au versement, sans quitter NeoProf.',
  compliance: "Crédit d'impôt de 50 % sous conditions. NeoProf n'est pas affilié à l'URSSAF.",
  simulate: 'Simuler mes gains',
  prepare: 'Préparer ma demande',
  skip: 'Passer',
  replay: 'Revoir',
  idle: 'Tu veux voir combien tu gagnes ?',
  invoice: 'Facture',
  example: 'Exemple illustratif · Alex',
  invoiceLabel: 'Cours de maths · 2 h',
  credit: 'Avance immédiate URSSAF',
  remaining: 'Reste à payer par la famille',
  amount: '100,00 €',
  creditAmount: '−50,00 €',
  familyAmount: '50,00 €',
  flowEyebrow: 'De la séance au virement',
  flow: ['Tu envoies la demande.', 'La famille valide sur son espace URSSAF.', 'L’URSSAF te verse les 100 €.'],
  requestTitle: 'Récapitulatif de la demande',
  requestLead: 'Cours de maths · Alex',
  requestHeaders: ['Mois', 'Libellé', 'Montant TTC'],
  requestMonth: 'Octobre',
  requestLesson: 'Cours de maths',
  total: 'Total',
  cancel: 'Annuler',
  send: 'Confirmer l’envoi',
  sent: 'Demande envoyée',
  toSend: 'À envoyer',
  sentLead: 'La demande de paiement a bien été transmise à l’URSSAF.',
  validated: 'La famille valide sur son espace URSSAF.',
  paid: 'Payé',
  fullPayment: '+100,00 €',
  eligibilityEyebrow: '4 questions · 30 secondes',
  eligibilityTitle: 'Tu peux la proposer à tes familles ?',
  eligibilityLead: 'Réponds : tu obtiens ton plan et les liens pour chaque étape.',
  conditions: 'Les conditions sur urssaf.fr',
  progress: (step, total) => `Question ${step} sur ${total}`,
  back: 'Retour',
  restart: 'Refaire le test',
  onlineTitle: 'L’Avance immédiate ne couvre pas la visio.',
  onlineLead: 'Elle porte sur les cours au domicile de l’élève. NeoProf reste utile pour tes factures et ton planning.',
  mixedLead: 'Seuls tes cours à domicile passent en Avance immédiate.',
  planTitle: 'Ton plan avant ta première demande',
  ready: 'Tes démarches sont renseignées.',
  readyLead: 'Vérifie aussi l’éligibilité de chaque famille et les conditions du service avant ta première demande.',
  done: 'C’est fait.',
  activate: 'Active l’Avance immédiate dans NeoProf',
  activateLead: 'Tu inscris tes familles et tu envoies tes demandes après les séances.',
  faqTitle: 'Les réponses à tes questions.',
  related: {
    title: 'Et tes factures, au même endroit ?',
    lead: 'Prépare tes factures à partir de tes séances dans NeoProf.',
    features: ['Retrouve le détail des séances facturées.', 'Télécharge ta facture en PDF.', 'Consulte les paiements enregistrés et le solde.'],
  },
  finalTitle: 'Ta prochaine séance peut déjà passer en Avance immédiate.',
  email: 'Ton adresse email',
  emailPlaceholder: 'ton@email.fr',
  continue: 'Continuer vers l’inscription',
  signupPending: 'Envoi du code…',
  signupError: 'Impossible d’envoyer le code. Réessaie.',
  authPitch: {
    eyebrow: 'Ton espace NeoProf',
    title: 'Tes factures et tes familles,',
    highlight: 'au même endroit.',
    subtitle: 'Crée ton espace pour préparer ta première facture et tes démarches d’Avance immédiate.',
    bullets: ['Tes factures et leurs paiements', 'Tes familles et leurs coordonnées', 'Tes démarches d’Avance immédiate'],
  },
  cta: PUBLIC_OFFER_COPY.neutralCta,
  trial: PUBLIC_OFFER_COPY.neutralTrial,
  seo: {
    applicationName: 'NeoProf Pro',
    home: 'Accueil',
    imageAlt: 'NeoProf, logiciel de gestion des cours particuliers',
    answer: 'NeoProf permet aux professeurs particuliers de préparer leurs factures, transmettre les demandes d’Avance immédiate et suivre leur statut. Pour les cours à domicile éligibles, la famille règle sa part et le professeur reçoit le prix total : crédit d’impôt de 50 % sous conditions.',
    offerDescription: (months) => `${months} mois d’essai sans carte bancaire. ${PUBLIC_OFFER_COPY.pricesTaxIncluded}.`,
    cinematicTitle: 'Doubler ton tarif avec l’Avance immédiate — NeoProf',
    professionalTitle: 'Logiciel Avance immédiate pour prof particulier — NeoProf',
    description: 'Propose l’Avance immédiate pour tes cours particuliers à domicile : la famille règle sa part, tu reçois le prix total. Simulateur, démarches et suivi NeoProf.',
  },
  guide: 'Lire le guide',
  questions: [
    { id: 'place', title: 'Tes cours ont lieu où ?', positive: ['home', 'both'], options: [['home', 'Au domicile de l’élève'], ['both', 'À domicile et en visio'], ['online', 'En visio seulement']] },
    { id: 'status', title: 'Tu factures sous quel statut ?', positive: ['micro', 'company'], options: [['micro', 'Micro-entrepreneur'], ['company', 'Entreprise (EI, EURL, SASU…)'], ['none', 'Pas encore de statut'], ['cesu', 'Les familles me paient en CESU']] },
    { id: 'sap', title: 'Ton activité est déclarée en services à la personne (SAP) ?', positive: ['yes'], options: [['yes', 'Oui'], ['no', 'Non'], ['unsure', 'Je ne sais pas']] },
    { id: 'api', title: 'Tu as l’habilitation URSSAF « API Tiers de prestation » ?', positive: ['yes'], options: [['yes', 'Oui'], ['no', 'Non'], ['what', 'C’est quoi ?']] },
  ],
  steps: {
    company: { title: 'Crée ton entreprise', text: 'Pour facturer tes cours en ton nom. La création se fait en ligne.', cesu: 'En CESU, c’est la famille qui déclare. Pour envoyer toi-même les demandes, tu factures comme prestataire.', label: 'Guichet unique des entreprises' },
    sap: { title: 'Déclare ton activité en services à la personne', text: 'Le soutien scolaire à domicile se déclare sur NOVA.', label: 'NOVA' },
    api: { title: 'Demande l’habilitation URSSAF', text: 'Elle autorise l’envoi des demandes de paiement. Une fois obtenue, tu la relies à NeoProf.', label: 'API Tiers de prestation' },
  },
  faq: [
    { id: 'cost', question: 'La famille paie-t-elle plus cher ?', answer: 'Pour un cours éligible de 100 €, la famille règle 50 € et tu reçois le prix total. Le crédit d’impôt de 50 % reste soumis aux conditions et plafonds applicables.' },
    { id: 'sap', question: 'Faut-il être déclaré en services à la personne ?', answer: 'Oui. L’activité doit être déclarée en services à la personne (SAP), puis habilitée par l’URSSAF. NeoProf permet d’inscrire les familles, de transmettre les demandes et de suivre leurs statuts. NeoProf n’accorde ni la déclaration ni l’habilitation.' },
    { id: 'online', question: 'Les cours en visio ouvrent-ils droit à l’Avance immédiate ?', answer: 'Le soutien scolaire SAP porte sur des cours au domicile de l’élève. Un cours en visio se propose et se facture à part, sans Avance immédiate.' },
    { id: 'refused', question: 'Et si une demande est refusée ?', answer: 'Chaque demande garde son statut URSSAF dans NeoProf. Une demande contestée se règle avec la famille. Un paiement n’est pas affiché comme reçu avant sa confirmation.' },
    { id: 'independence', question: 'NeoProf est-il lié à l’URSSAF ?', answer: "NeoProf n'est pas affilié à l'URSSAF. Tu utilises le service avec ton habilitation. Le crédit d'impôt de 50 % sous conditions dépend de l’éligibilité des cours et de la famille." },
  ],
});

export const AVANCE_LANDING_ANGLES = Object.freeze({
  tarif: Object.freeze({ cinematic: AVANCE_LANDING_COPY.cinematic, professionalTitle: AVANCE_LANDING_COPY.professionalTitle, professionalLead: AVANCE_LANDING_COPY.professionalLead }),
  famille: Object.freeze({ cinematic: ['Un cours à 100 €…', 'la famille ne règle que 50 € ?', ...AVANCE_LANDING_COPY.cinematic.slice(2)], professionalTitle: 'La famille règle sa part. Tu reçois le prix total.', professionalLead: 'Pour les cours à domicile éligibles, le crédit d’impôt est déduit du paiement de la famille, sous conditions.' }),
  simple: Object.freeze({ cinematic: ['Ta facture est prête…', 'la demande d’Avance immédiate aussi.', ...AVANCE_LANDING_COPY.cinematic.slice(2)], professionalTitle: 'Tes demandes d’Avance immédiate, depuis tes factures.', professionalLead: 'Prépare les demandes pour tes familles et retrouve leur statut dans NeoProf.' }),
});

